import { CallLogsTopBarActions, CallLogsView } from '@elva/ui';
import { usePageTopBar } from '@/app/layouts/pageTopBar';

export function CallLogsPage() {
  usePageTopBar({
    actions: <CallLogsTopBarActions />,
  });

  return (
    <div className="-m-6 flex min-h-full flex-1">
      <CallLogsView />
    </div>
  );
}
